<template>
  <!-- 需求详情 -->
  <div class="needInfoWrap">
      <v-downTip :popShow="popShow" ></v-downTip>
      <v-shareHeader :content="shareSwiper"></v-shareHeader>
      <v-shareFooter :content="shareSwiper"></v-shareFooter>
     <div class="wrapDiv">
       <!-- 需求标题 -->
       <div class="needTitle">
         <p class="p1">{{baseData.demandTitle}} 
            <span class="status" v-if="pageType ==2">
              {{baseData.demandStatus == 1 ? '待解决' : (baseData.demandStatus == 2 ? '已解决' : '已取消')}}
            </span>
         </p>
         <p class="p2">{{baseData.demandRegion}}<span>{{baseData.createTime}}</span></p>
         <div v-if="pageType == 1" class="icon">
           <img src="../images/yfb.png" alt="" v-if="baseData.demandStatus == 1">
           <img src="../images/yjj.png" alt="" v-if="baseData.demandStatus == 2">
           <img src="../images/yqx.png" alt="" v-if="baseData.demandStatus == 3">
         </div>
       </div>
       <div class="line"></div>
       <!-- 需求类型 -->
       <div class="needType">
         <p>需求类型 <span>{{baseData.demandType}}</span></p>
         <p class="p2">价格范围 <span>{{baseData.demandPrice}}</span></p>
         <p>企业名称 <span>{{baseData.companyName}}</span></p>
       </div>
       <div class="line"></div>
       <!-- 需求描述 -->
       <div class="needData">
         <div class="title"><img src="../images/xqms.png" alt="">需求描述</div>
         <div class="con" v-html="baseData.demandExplain"></div>
       </div>
       <div class="imgbox" v-if="baseData.imagesURL">
         <img :src="baseData.imagesURL+'?x-oss-process=style/demand'" alt="">
       </div>
     </div>
     <div class="footer" v-if="pageType == 2 && baseData.demandStatus == 1"><div @click="toStore">{{baseData.demandMobile}}</div></div>
     <div class="footer2" v-if="pageType == 1 && baseData.demandStatus == 1">
       <div class="cancel" @click="toStore">取消</div>
       <div class="ok"  @click="toStore">解决</div>
     </div>
    <v-morerepeat :actionId="$route.query.accountId" :shareSwiper="shareSwiper" :isshare="true" :datatype="7"></v-morerepeat>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      baseData:{},
      pageType:0,
      token:"",
      popShow:false,
      shareSwiper:'',
    }
  },
  created(){
    this.init();
  },
  mounted(){
    weixin.shareInfo(7,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(7,this.$route.query.contentId,(data)=>{
      this.shareSwiper = data;
    });
    
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    },
    init(){
      // this.$http.get("content/app/demand/query/id?demandId="+"5a780e4010d824307c3efcd8"+"&accountId=32")
      this.$http.get("content/app/demand/query/id?demandId="+this.$route.query.contentId+"&accountId="+this.$route.query.accountId)
      .then((response) => {
        this.baseData =  response.respData;
        this.pageType = response.respData.isOneself;       
      });
    },
  }
}
</script>

<style lang="less">
.needInfoWrap{
  .wrapDiv{
    .needData{
      .con{
        font-size:32px;
        img,video,table{
          max-width: 100%;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.needInfoWrap{
  margin: 88px 0;
  .wrapDiv{
    background: #fff;
    .needTitle{
      position: relative;
      padding: 28px 24px;
      .p1{
        font-weight: bold;
        font-size: 40px;
        line-height: 56px;
        color: #333440;
        margin-bottom: 20px;
        width:100%;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
        .status{
          font-size: 20px;
          color: #FFFFFF;
          padding: 4px 13px;
          background: #F3A117;
          border-radius: 4px;
          font-weight: normal;
        }
      }
      .p2{
        font-size: 24px;
        line-height: 34px;
        color: #A4A4A4;
        span{
          margin-left: 12px;
        }
      }
      .icon{
        position: absolute;
        top:32px;
        right: 28px;
        width: 218px;
        height: 184px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .line{
      height: 20px;
      background: #FBF6F6;
    }
    .needType{
      p{
        padding: 28px 30px 21px 30px;
        font-size: 28px;
        color: #333440;
        span{
          margin-left: 24px;
          font-size: 26px;
          color: #5B5C66;
        }
      }
      .p2{
        border-top:1px solid #EFEFEF;
        border-bottom:1px solid #EFEFEF;
      }
    }
    .needData{
      .title{
        padding: 0 30px;
        line-height: 84px;
        height: 84px;
        border-bottom:1px solid #EFEFEF;
        font-size: 28px;
        color: #333440;
        font-weight: bold;
        img{
          width: 32px;
          height: 32px;
          margin-right: 12px;
          vertical-align: middle;
        }
      }
      .con{
        padding: 18px 30px;
        img,video{
          max-width: 100%;
        }
      }
    }
    .imgbox{
      width:100%;
      height:500px;
      display:inline-block;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      text-align: center;
      overflow: hidden;
      img{
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
  }
  .footer{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    padding: 20px 30px;
    background: #FFFFFF;
    box-shadow: 0 -8px 8px 0 rgba(0,0,0,0.04);
    z-index: 2;
    div{
      height: 80px;
      line-height: 80px;
      text-align: center;
      font-size: 30px;
      color: #EF4B4B;
      font-weight: bold;
      border: 2px solid #EF4B4B;
      border-radius: 8px;
    }
  }
  .footer2{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    padding: 20px 30px;
    background: #FFFFFF;
    box-shadow: 0 -8px 8px 0 rgba(0,0,0,0.04);
    z-index: 2;
    .cancel{
      float: left;
      width: 166*2px;
      height: 80px;
      border: 2px solid #D1D1D1;
      border-radius: 8px;
      text-align: center;
      line-height: 80px;
      font-size: 30px;
      color: #A4A4A4;
    }
    .ok{
      float: right;
      width: 166*2px;
      height: 80px;
      background-image: linear-gradient(90deg, #EF4B4B 0%, #F7643C 100%);
      box-shadow: 4px 8px 20px 0 rgba(239,75,75,0.27);
      border-radius: 8px;
      text-align: center;
      line-height: 80px;
      font-size: 30px;
      color: #fff;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/share/shareneedInfo.vue